import { queryOptions } from '@tanstack/react-query';
import { linkDevicePeripheralOptions } from '~/pages/System/api/linkDevicePeripheralOptions.api';
import { LinkDevicePeripheralOptionsModel } from '~/pages/System/models/LinkDevicePeripheralOptionsModel';

export const linkDevicePeripheralOptionsQuery = ({
  deviceName,
}: {
  deviceName: string;
}) =>
  queryOptions({
    queryKey: [
      'linkDevicePeripheralOptions',
      {
        deviceName,
      },
    ],
    queryFn: async () => {
      const response = await linkDevicePeripheralOptions(deviceName);

      return new LinkDevicePeripheralOptionsModel(response);
    },
  });
